import { IS_SEND_CODE, SESSION_USER } from "./../../constants/login.constants";
import {
  IS_VERIFIED_AUTH,
  IS_VERIFIED_TYPE,
  REMEMBER_LOGIN,
  REMEMBER_VERIFY,
  USER_TOKEN_TYPE,
} from "constants/login.constants";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfileUser } from "shared/models/profile.model";
import { cookiesStorage } from "shared/helpers/cookiesStorage";
import { DAYS_EXPIRED_TOKEN } from "constants/common.constants";

interface UserProps extends ProfileUser {
  token: string;
  password: string;
  defaultRoute: string;
  merchantId?: number;
  isVerify2faEmail: boolean;
  isVerify2faGa: boolean;
  isVerifyPassword: boolean;
  isRefetchMerchant: boolean;
  verified: boolean;
  public_key: string;
  merchantIdDashboard: string;
  currencySelected: string;
  use_new_payout_report: boolean;
  user_type: string;
  dataCurrencies: { code: string; name: string }[];
}

const initialState: UserProps = {
  token: "",
  roleId: 0,
  public_key: "",
  dataCurrencies: [],
  merchantIdDashboard: "",
  verified: false,
  isVerify2faEmail: false,
  isVerifyPassword: false,
  isVerify2faGa: false,
  defaultRoute: "",
  "2fa_setuped_at": "",
  authenticator_type: "",
  created_at: "",
  email: "",
  email_verified_at: "",
  external_user_id: "",
  id: "",
  last_name: "",
  name: "",
  password: "",
  password_changed_at: "",
  permissions: [],
  phone_number: "",
  roles: "",
  status: 1,
  updated_at: "",
  merchantId: 0,
  isRefetchMerchant: false,
  currencySelected: "AUD",
  use_new_payout_report: false,
  user_type: "",
};

const userSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string; password: string }>) => {
      state.token = action.payload.token;
      state.password = action.payload.password;
    },
    updateProfile: (state, action: PayloadAction<ProfileUser>) => {
      const newState = {
        "2fa_setuped_at": action.payload["2fa_setuped_at"],
        authenticator_type: action.payload.authenticator_type,
        created_at: action.payload.created_at,
        email: action.payload.email,
        email_verified_at: action.payload.email_verified_at,
        external_user_id: action.payload.external_user_id,
        id: action.payload.id,
        last_name: action.payload.last_name,
        name: action.payload.name,
        password_changed_at: action.payload.password_changed_at,
        permissions: action.payload.permissions,
        phone_number: action.payload.phone_number,
        roles: action.payload.roles,
        status: action.payload.status,
        roleId: action.payload.roleId,
        updated_at: action.payload.updated_at,
        use_new_payout_report: action.payload.use_new_payout_report,
        user_type: action.payload.user_type,
      };
      return (state = { ...state, ...newState });
    },
    successVerify: (state) => {
      cookiesStorage.set(IS_VERIFIED_TYPE, JSON.stringify(true), DAYS_EXPIRED_TOKEN);
      state.password_changed_at = new Date().toISOString();
      state.verified = true;
    },
    logout: (state) => {
      cookiesStorage.remove(USER_TOKEN_TYPE);
      cookiesStorage.remove(REMEMBER_LOGIN);

      cookiesStorage.remove(USER_TOKEN_TYPE);
      cookiesStorage.remove(IS_SEND_CODE);
      cookiesStorage.remove("permissions");
      cookiesStorage.remove(IS_VERIFIED_TYPE);
      cookiesStorage.remove(IS_VERIFIED_AUTH);

      sessionStorage.removeItem(SESSION_USER);
      // cookiesStorage.remove(REMEMBER_VERIFY);
      // cookiesStorage.remove(REMEMBER_LOGIN);

      return (state = {
        ...initialState,
        merchantId: 0,
        merchantIdDashboard: "",
        currencySelected: "AUD",
      });
    },
    updateDataCurrencies: (
      state,
      action: PayloadAction<{ code: string; name: string; symbol: string }[]>
    ) => {
      state.dataCurrencies = action.payload;
    },
    updateMerchantId: (state, action: PayloadAction<number>) => {
      state.merchantId = action.payload;
    },
    updateMerchantIdDashboard: (state, action: PayloadAction<string>) => {
      state.merchantIdDashboard = action.payload;
    },
    updateCurrencySelected: (state, action: PayloadAction<string>) => {
      state.currencySelected = action.payload;
    },
    updatePublickey: (state, action: PayloadAction<string>) => {
      state.public_key = action.payload;
    },
    updateAuth: (
      state,
      action: PayloadAction<{
        isVerify2faEmail: boolean;
        isVerify2faGa: boolean;
        isVerifyPassword: boolean;
      }>
    ) => {
      cookiesStorage.set(
        IS_VERIFIED_AUTH,
        JSON.stringify({
          isVerify2faEmail: action.payload.isVerify2faEmail,
          isVerify2faGa: action.payload.isVerify2faGa,
          isVerifyPassword: action.payload.isVerifyPassword,
        }),
        DAYS_EXPIRED_TOKEN
      );

      state.isVerify2faEmail = action.payload.isVerify2faEmail;
      state.isVerify2faGa = action.payload.isVerify2faGa;
      state.isVerifyPassword = action.payload.isVerifyPassword;

      if (cookiesStorage.get(REMEMBER_LOGIN)) {
        cookiesStorage.set(
          IS_VERIFIED_AUTH,
          JSON.stringify({
            isVerify2faEmail: action.payload.isVerify2faEmail,
            isVerify2faGa: action.payload.isVerify2faGa,
            isVerifyPassword: action.payload.isVerifyPassword,
          })
        );
      }
    },
    refetchMerchant: (state, action) => {
      state.isRefetchMerchant = action.payload;
    },
  },
});

export default userSlice.reducer;

export const {
  login,
  logout,
  updateProfile,
  successVerify,
  updateMerchantId,
  updateAuth,
  updatePublickey,
  refetchMerchant,
  updateDataCurrencies,
  updateMerchantIdDashboard,
  updateCurrencySelected,
} = userSlice.actions;
